import React, { useState } from "react";
import { Typography, Chip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MappableFieldsDescriptionModal from "./MappableFieldsDescriptionModal";

export function MappableFieldsInfo({ availableFields, resources, chipClass }) {
  const [showMappableFields, setShowMappableFields] = useState(false);

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}
    >
      <Typography variant="caption" color="textSecondary">
        {resources["MappableFieldsInfoCaption"]}
      </Typography>
      <Chip
        size="small"
        icon={<VisibilityIcon />}
        label={`${availableFields.length} ${resources["MappableFieldsAvailable"]}`}
        className={chipClass}
        color="primary"
        onClick={() => setShowMappableFields(true)}
      />

      <MappableFieldsDescriptionModal
        open={showMappableFields}
        onClose={() => setShowMappableFields(false)}
        resources={resources}
        mappableFields={availableFields}
      />
    </div>
  );
}
